import React, { FC, useMemo, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import _sortBy from 'lodash/sortBy';
import { useDrawerSearchFilterNameOrCategory, useDrawerFiltersCounts, useDrawerGlobalLoader } from '@minecraft.drawer';
import ErrorMessage from '@minecraft.error-message';
import {
  FormItem,
  useFiltersLabel,
  generateSelectOptionsBasedOnField,
  FiltersNameEnum,
  FilterDrawerType,
} from '@blocs.filter';
import { FiltersCategoryNameEnum, FiltersCountNameEnum } from '../../shared/types';
import { UniqueAttributes } from '../../FilterDrawerCollection';
import { QUERY_UNIQUE_ATTRIBUTES } from './UniqueAttributesCategoryGraphQL';

interface Props {
  type: FilterDrawerType;
}

const UniqueAttributesCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { data, error, loading } = useQuery(QUERY_UNIQUE_ATTRIBUTES);

  const { isCategoryMatchedSearch, assignOptionsToCategoryFilters } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.uniqueAttributes
  );
  const { filtersCounts } = useDrawerFiltersCounts();

  const uniqueAttributeOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(
      _sortBy(data?.uniqueAttributes, 'name'),
      'name',
      false,
      filtersCounts?.[FiltersCountNameEnum.uniqueAttributeIds]
    );
  }, [data, filtersCounts]);

  useDrawerGlobalLoader(loading);

  useEffect(() => {
    if (uniqueAttributeOptions.length > 0) {
      assignOptionsToCategoryFilters({
        [FiltersNameEnum.uniqueAttributes]: uniqueAttributeOptions,
      });
    }
  }, [uniqueAttributeOptions]);

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <UniqueAttributes
          name={FiltersNameEnum.uniqueAttributes}
          label={filtersLabelOfAudience[FiltersNameEnum.uniqueAttributes]}
        />
      </FormItem>
    )
  );
};

export default UniqueAttributesCategory;
